// ---------------------------------------------------------------------------
// src/pages/campaigns/creator/conversation/index.js
// ---------------------------------------------------------------------------
import React, { useRef, useState } from "react";
import { useQuery } from "react-query";
import { Alert, IconButton, Badge, Box } from "@mui/material";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

import client from "../../../../API";
import { useCreatorAuth } from "../../../../Hooks/creator-use-auth";
import ChatScreen from "../../../../Components/ChatScreen";

const CreatorCampaignConversation = ({ campaignId }) => {
  /* ------------------------------------------------------------
     Auth / conversation bootstrap
  ------------------------------------------------------------ */
  const { creatorToken } = useCreatorAuth();

  const {
    data: checkResults,
    isLoading: isChecking,
    error,
  } = useQuery({
    queryKey: ["messagesId", campaignId],
    queryFn: () =>
      client.conversations.checkCampaign({
        campaign_id: campaignId,
        creator_id: creatorToken.creator_user.username,
      }),
    refetchOnWindowFocus: false,
  });

  const convId = checkResults?.exists ? checkResults.conversation_id : null;

  /* ------------------------------------------------------------
     Deliverable badge + scroll helper
  ------------------------------------------------------------ */
  const [ineligibleCount, setIneligibleCount] = useState(0);
  const chatRef = useRef(null);

  /* ------------------------------------------------------------
     Render
  ------------------------------------------------------------ */
  if (isChecking) return null; // parent already shows spinner

  return (
    <>
      {!!error && (
        <Alert severity="error">
          {error?.response?.data?.error || error.message}
        </Alert>
      )}

      {/* Deliverable badge row */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          mb: 1,
        }}
      >
        <IconButton
          color="secondary"
          disabled={ineligibleCount === 0}
          aria-label="Show ineligible deliverables"
          onClick={() =>
            chatRef.current?.scrollToFirstIneligibleVideo?.()
          }
        >
          <Badge
            badgeContent={ineligibleCount}
            color="error"
            invisible={ineligibleCount === 0}
          >
            <AssignmentTurnedInIcon />
          </Badge>
        </IconButton>
      </Box>

      {/* Chat */}
      <ChatScreen
        ref={chatRef}
        conversationId={convId}
        sx={{ flex: 1, minHeight: "0px" }}
        showWarning={false}
        /* 🔄 keep badge count in sync */
        onDeliverablesUpdate={(list) => setIneligibleCount(list.length)}
      />
    </>
  );
};

export default CreatorCampaignConversation;
